import type { StoreType } from '@frodo/models/types';

export const toKebabCase = (str: string): string => {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};

export const isNumber = (value: string) => {
  return !Number.isNaN(parseInt(value));
};

export const parseSemicolonSeparated = (raw: string): string[] => {
  if (!raw) return [];

  try {
    return decodeURIComponent(raw)
      .split(';')
      .map(value => value.trim())
      .filter(Boolean);
  } catch {
    return [];
  }
};

export const parseJsonStringArray = (raw: string): string[] => {
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];

    return parsed.filter((item): item is string => typeof item === 'string');
  } catch {
    return [];
  }
};

export const formatIsoDate = (isoDate: string, store: StoreType): string => {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat(store.locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
};
